var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-card',{staticClass:"text-center st-score mb-4",attrs:{"title":"ผลสอบทั้งหมด"}},[_c('b-card-text',[(_vm.examAnswerSheetPending)?[_vm._v(" กำลังโหลด ")]:[_c('ExamTakerAnswerChart',{attrs:{"height":_vm.chartHeight,"dataset":_vm.dataset}})]],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }